// ============================================================
// AI Engine — Pluggable AI interface
// ============================================================

import { type BoardState, type Move } from '@core/types';
import { formatMove } from '@core/notation';
import { search, type SearchResult } from './search';

export interface AIEngine {
  name: string;
  think(state: BoardState): Promise<Move>;
}

/** Classical minimax AI with iterative deepening + time control */
export function createClassicalAI(depth: number = 3): AIEngine {
  return {
    name: `Classical (depth ${depth})`,

    async think(state: BoardState): Promise<Move> {
      return new Promise((resolve, reject) => {
        // Use requestAnimationFrame to let the UI update first, then compute
        setTimeout(() => {
          const result: SearchResult = search(state, depth);

          if (!result.move) {
            reject(new Error('No legal moves'));
            return;
          }

          console.log(
            `AI [${this.name}]: ${formatMove(result.move)} ` +
            `(score: ${result.score}, depth: ${result.depth}/${depth}, ` +
            `nodes: ${result.nodesSearched}, ${result.timeMs.toFixed(0)}ms)`
          );

          resolve(result.move);
        }, 50); // 50ms delay to let "thinking..." render
      });
    },
  };
}

/** Future: GLADIUS neural AI */
// export function createGladiusAI(modelUrl: string): AIEngine { ... }
